import { render, staticRenderFns } from "./TableButtonsEditChangeGeometry.vue?vue&type=template&id=dd963b98&scoped=true&"
import script from "./TableButtonsEditChangeGeometry.vue?vue&type=script&lang=js&"
export * from "./TableButtonsEditChangeGeometry.vue?vue&type=script&lang=js&"
import style0 from "./TableButtonsEditChangeGeometry.vue?vue&type=style&index=0&id=dd963b98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd963b98",
  null
  
)

export default component.exports